import { service, axios } from '@/utils/request'

import qiniu from './v1/qiniu'

import user from './v1/user'
import role from './v1/role'
import admin from './v1/admin'
import auth from './v1/auth'
import menu from './v1/menu'
import texture from './v1/texture'
import assets from './v1/assets'
import materialDirection from './v1/materialDirection'
import planning from './v1/planning'
import wow from './v1/wow'
const api = {
  install (Vue) {
    Vue.prototype.$api = api
    Vue.prototype.$http = service
    Vue.prototype.$third = axios
  },
  qiniu,
  user,
  role,
  admin,
  auth,
  menu,
  texture,
  assets,
  materialDirection,
  planning,
  wow
}

export default api
